import { render, staticRenderFns } from "./SpecialEffects.vue?vue&type=template&id=028477cf&scoped=true"
import script from "./SpecialEffects.vue?vue&type=script&lang=js"
export * from "./SpecialEffects.vue?vue&type=script&lang=js"
import style0 from "./SpecialEffects.vue?vue&type=style&index=0&id=028477cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028477cf",
  null
  
)

export default component.exports